export default {
    catalogItemModel: function(catalogItem, filterValue)
    {
        return catalogItem.id == filterValue
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/site/components/catalog-filter/filterable.js